export default __webpack_public_path__ + "static/media/facebookwhite.1a8ced0a.svg";